import { Check } from "lucide-react";
import type { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  ToggleGroupInput,
  ToggleGroupInputItem,
} from "@/components/shared/form/toggle-group-input";
import type { FormValues } from "./formSchema";

interface UserTypeStepProps {
  form: UseFormReturn<FormValues>;
}

export const UserTypeStep = ({ form }: UserTypeStepProps) => {
  const { t } = useTranslation();
  const value = form.watch("userType");

  return (
    <div className="max-w-[600px] mx-auto">
      <h2 className="text-2xl font-semibold mb-6">
        {t("users.select_user_type")}
      </h2>
      <ToggleGroupInput<"company" | "accounting_firm">
        name="userType"
        className="grid grid-cols-2 gap-4"
      >
        <ToggleGroupInputItem
          value="company"
          className="rounded-lg border text-card-foreground shadow-sm h-14 px-4 cursor-pointer transition-all duration-200 hover:bg-gray-50 hover:border-gray-300 bg-white border-gray-200"
        >
          <div className="flex items-center justify-center gap-3 h-full">
            <div
              className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all duration-200 ${value === "company" ? "bg-black border-black" : "border-gray-400"}`}
            >
              {value === "company" && <Check className="w-3 h-3 text-white" />}
            </div>
            <span className="text-sm font-medium">
              {t("users.user_type.company")}
            </span>
          </div>
        </ToggleGroupInputItem>

        <ToggleGroupInputItem
          value="accounting_firm"
          className="rounded-lg border text-card-foreground shadow-sm h-14 px-4 cursor-pointer transition-all duration-200 bg-white border-gray-300"
        >
          <div className="flex items-center justify-center gap-3 h-full">
            <div
              className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all duration-200 ${value === "accounting_firm" ? "bg-black border-black" : "border-gray-400"}`}
            >
              {value === "accounting_firm" && (
                <Check className="w-3 h-3 text-white" />
              )}
            </div>
            <span className="text-sm font-medium">
              {t("users.user_type.accounting_firm")}
            </span>
          </div>
        </ToggleGroupInputItem>
      </ToggleGroupInput>
    </div>
  );
};
